// removed by extract-text-webpack-plugin
module.exports = {"Main":"src-components-List-__ListDisplay-module___Main","Aside":"src-components-List-__ListDisplay-module___Aside","Content":"src-components-List-__ListDisplay-module___Content","List":"src-components-List-__ListDisplay-module___List"};


//////////////////
// WEBPACK FOOTER
// ./src/components/List/ListDisplay.module.css
// module id = 1204
// module chunks = 1